
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useFingerprint } from "@/utils/useFingerprint";
import { getAffiliateIdFromCookie, getCampaignCookie, getReferralCodeFromCookie } from "@/hooks/referrals/referralUtils";
import { isWebview } from "@dvlden/is-webview";

const HeroSection = () => {
  const {store } = useFingerprint();
  const isWebView = isWebview(window.navigator.userAgent);


  const storeFingerPrintIfNeeded = async () => {
    if((getCampaignCookie() || getAffiliateIdFromCookie() || getReferralCodeFromCookie())){
      await store();
    }
  }

  return (
    <section className="relative min-h-[70vh] flex items-center justify-center">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0" style={{
        backgroundImage: 'url("/lovable-uploads/6a93bfa2-7afa-404d-8a62-9c96df3c95ee.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        {/* Dark overlay with corporate color */}
        <div className="absolute inset-0 bg-corporate-primary-100 opacity-90"></div>
      </div>

      <div className="container mx-auto relative z-10 px-4 py-12 md:py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-corporate-white mb-4 md:mb-6">
            Marketplace for free and verified crypto trading strategies
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-corporate-neutral-25 mb-6 md:mb-8 px-4 md:px-0">
            Our marketplace takes care of your crypto success with proven trading strategies.
          </p>

          <Link to="/signup">
            <Button className="bg-corporate-secondary-100 hover:bg-corporate-secondary-75 text-corporate-neutral-100 px-6 md:px-8 py-3 md:py-6 text-base md:text-lg font-semibold rounded-lg shadow-lg transform transition-all duration-200 hover:scale-105">
              Get Started Now
              <ArrowRight className="ml-2 h-5 md:h-6 w-5 md:w-6" strokeWidth={2.5} />
            </Button>
          </Link>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 p-6">
            {/* Google Play Store */}
            {<a
              href="https://play.google.com/store/apps/details?id=app.metrade.app"
              onClick={async () => await storeFingerPrintIfNeeded() }
              target="_blank"
              rel="noopener noreferrer"
              className="w-64 flex flex-col items-center text-center gap-2 px-4 py-3 text-white rounded-xl hover:opacity-90 transition"
            >
              <img
                src="google_badge.svg"
                alt="Google Play"
                className="h-12"
              />
              <span className="text-lg font-medium">Get it on Google Play</span>
            </a>}

            {/* Apple Store - Coming Soon */}
            {<div className="w-64 flex flex-col items-center text-center gap-2 px-4 py-3 text-white rounded-xl opacity-60 cursor-not-allowed">
              <img
                src="apple_badge.svg"
                alt="App Store"
                className="h-12"
              />
              <span className="text-sm">Coming Soon</span>
            </div>}
          </div>


        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
